import React, { useMemo, useState } from 'react';
import styled from 'styled-components';

import Chart from '../../../chart/Chart';
import ChartWrapper from '../../../chart/dashboard/ChartWrapper';
import toConversionConfig from '../../../chart/dashboard/FunnelChartConfig';
import FunnelLabelsPane from '../../../containers/dashboards/preview/FunnelLabelsPane';

const StyledFunnelChartContainer = styled.div`
  height: 100%;

  .main {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .st-labels-chart {
    overflow-y: auto;
  }
`;

const FunnelChart = ({ data, options, executeTime, view, unit, setChart }) => {
  const [isShowLabels, setIsShowLabels] = useState(false);

  const triggerLabels = () => {
    setIsShowLabels((prevState) => !prevState);
  };

  const config = useMemo(
    () => toConversionConfig(data, options, view, unit, triggerLabels),
    [data, options, view, unit]
  );

  return (
    <StyledFunnelChartContainer>
      {data && (
        <div className="main">
          <ChartWrapper height={isShowLabels ? '65%' : '100%'} unit={unit} setChart={setChart}>
            <MemoChart key={executeTime} config={config} unitId={unit?.id} />
          </ChartWrapper>
          {isShowLabels && (
            <div className="st-labels-chart">
              <FunnelLabelsPane fromDashboard unit={unit} />
            </div>
          )}
        </div>
      )}
    </StyledFunnelChartContainer>
  );
};

const MemoChart = React.memo((props) => <Chart {...props} />);

export default FunnelChart;
